<template>
	<div class="chat-helper-se-container">
		<div class="chat-helper-se-title">
			群发状态
		</div>
		<div class="chat-helper-se-item">
			<div class="chat-helper-sei-progress layui-progress layui-progress-big" lay-showPercent="yes" lay-filter="sender-progress">
				 <div class="layui-progress-bar layui-bg-blue" lay-percent="0%"></div>
			</div>
		</div>
		<div v-if="taskStatus != -2">
			<div class="chat-helper-se-item">
				<span class="chat-helper-sei-option" v-if="taskStatus == -1" @click="start">开始</span>
				<span class="chat-helper-sei-option chat-helper-se-bg-orange" v-if="taskStatus == 1" @click="suspend">暂停</span>
				<span class="chat-helper-sei-option chat-helper-se-bg-blue"  v-if="taskStatus == 0" @click="continued">继续</span>
				<span class="chat-helper-sei-option chat-helper-se-bg-red"  v-if="taskStatus != -2" @click="deleteTask">删除</span>
			</div>
			<div class="chat-helper-se-item div-flex">
				<div class="chat-helper-sei-status"></div>
				<div class="chat-helper-sei-title">任务状态：</div>
				<div class="chat-helper-sei-text" v-html="statusText[taskStatus]"></div>
			</div>
			<div class="chat-helper-se-item div-flex">
				<div class="chat-helper-sei-status"></div>
				<div class="chat-helper-sei-title">开始时间：</div>
				<div class="chat-helper-sei-text">{{senderTime}}</div>
			</div>
			<div class="chat-helper-se-item div-flex">
				<div class="chat-helper-sei-status"></div>
				<div class="chat-helper-sei-title">剩余个数：</div>
				<div class="chat-helper-sei-text">任务总数（<span style="color: green;font-weight: bold;">{{total}}</span>），当前推送第（<span style="color: red;font-weight: bold;">{{currentNum}}</span>）个</div>
			</div>
			<div class="chat-helper-se-item div-flex">
				<div class="chat-helper-sei-status"></div>
				<div class="chat-helper-sei-title">任务摘要：</div>
				<div class="chat-helper-sei-text">好友总数（{{fansLength}}），消息总数（{{tempMsgOpt.msgList.length}}），客服并发发送（{{tempMsgOpt.fansGroupOpen ? '开启' : '关闭'}}），发送类型（{{tempMsgOpt.sendType === 1 ? '以消息为单位' : '以好友为单位'}}），消息间隔时间（{{tempMsgOpt.msgMinTime}}-{{tempMsgOpt.msgMaxTime}}）秒，好友间隔时间（{{tempMsgOpt.fansMinTime}}-{{tempMsgOpt.fansMaxTime}}）秒</div>
			</div>
			<div class="chat-helper-se-item div-flex">
				<div class="chat-helper-sei-status"></div>
				<div class="chat-helper-sei-title">注意事项：</div>
				<div class="chat-helper-sei-text chat-helper-se-color-orange">
					1.如发现进度无变化，可重启任务；2.群发任务最多只能存在一个；3.任务状态切换时，如发现状态不准确，请稍等片刻。
				</div>
			</div>
		</div>
		<div v-else>
			<div class="chat-helper-se-item">
				<span class="chat-helper-sei-option chat-helper-se-bg-orange" @click="reSetTask">重新设置任务</span>
			</div>
			<div class="chat-helper-se-item">
				<p class="chat-helper-se-color-orange">群发任务已完成或任务参数有误，请返回第一页重新设置！！！</p>
			</div>
		</div>
	</div>
</template>

<script>
	import {getCurrentTime} from '../../../functions/Common.js'
	import {sendMsg} from '../../../socket/socketSender.js'
	
	export default{
		name:'ChatHelperStepThree',
		props:{
			fans:{
				type: Array,
				default: []
			},
			msgOpt:{
				type: Object,
				default: {}
			},
		},
		
		data(){
			return {
				taskStatus: -1,  // 0,暂停中；1，运行中;-1,已停止，需要重新启动；-2，当前无任务
				cacheFansKey: 'ChatHelperFansList',  // 缓存的任务粉丝列表key
				cacheOptKey: 'ChatHelperMsgOpt',// 缓存的任务选项
				cacheTimeKey: 'ChatHelperStartTime',// 缓存的任务选项
				fansLength: 0,
				fansGroupMaxLen: 0,
				tempMsgOpt:{
					msgList:[]
				},
				statusText:{
					"-1":"<span class='chat-helper-se-color-red'>已停止</span>",
					"0":"<span class='chat-helper-se-color-orange'>暂停中</span>",
					"1":"<span class='chat-helper-se-color-blue'>运行中</span>",
				},
				element: null,
				total: 0,
				currentNum: 0,
				senderTime: ''
			}
		},
		
		methods:{
			init(){
				this.fansLength = 0
				this.fansGroupMaxLen = 0
				this.tempMsgOpt = {
					msgList:[]
				}
				this.total = 0
				this.currentNum = 0
				this.senderTime = ''
			},
			// 初始化子线程-定义顶级对象，避免对象变为null
			initWorker(){
				let _this = this
				if(window.senderWorker === undefined || window.senderWorker === null){
					window.senderWorker = new Worker('/js/sender.js?time='+(new Date).getTime())
					// 监听子线程的消息
					window.senderWorker.onmessage = function(event){
						// 缓存发送选项数据，防止页面刷新状态更改
						if(event.data.sendOpt !== undefined){
							localStorage.setItem(_this.cacheOptKey,JSON.stringify(event.data.sendOpt))
							_this.tempMsgOpt = event.data.sendOpt
						}
						if(event.data.msg !== undefined && event.data.fans !== undefined){
							let sendFans =  event.data.fans
							for (let i = 0; i < sendFans.length; i++) {
								_this.send(event.data.msg,sendFans[i])
							}
						}
						// 如果任务没结束或者任务没暂停，收到消息后就推送消息给子线程
						if(event.data.isEnd !== undefined && event.data.isEnd == 0){
							_this.computeProgress()
							if(_this.taskStatus === 0){
								return
							}
							_this.taskStatus = 1
							this.postMessage({
								runType: 'running'
							})
						}else{
							_this.close()
						}
					}
				}
			},
			
			// 开始任务
			start(){
				if(window.senderWorker === undefined || window.senderWorker === null){
					this.initWorker()
				}
				let data = this.senderData()
				if(data.friendList === undefined || data.friendList.length === 0 || data.sendOpt.msgList === undefined){
					this.taskStatus = -2
					return
				}
				this.taskStatus = 1
				data.runType = 'running'
				window.senderWorker.postMessage(data)	
			},
			
			// 暂停任务
			suspend(){
				this.taskStatus = 0
			},
			
			// 继续任务
			continued(){
				this.taskStatus = 1
				window.senderWorker.postMessage({
					runType: 'running'
				})	
			},
			
			// 删除任务
			deleteTask(){
				let _this = this
				CHAT_LAYER.open({
				  content: '删除任务后未发的消息将全部取消，你确定这样操作吗？'
				  ,btn: ['确认', '取消']
				  ,yes: function(index2, layero){
					  _this.close()
				      CHAT_LAYER.close(index2)
				  }
				  ,btn2: function(index, layero){
				    //按钮【按钮二】的回调
				    //return false 开启该代码可禁止点击该按钮关闭
				  }
				  ,cancel: function(){ 
				    //右上角关闭回调
				    //return false 开启该代码可禁止点击该按钮关闭
				  }
				})	
			},
			
			// 删除任务
			close(){
				localStorage.removeItem(this.cacheFansKey)
				localStorage.removeItem(this.cacheOptKey)
				localStorage.removeItem(this.cacheTimeKey)
				this.taskStatus = -2
				if(window.senderWorker === undefined || window.senderWorker === null){
					return
				}
				window.senderWorker.postMessage({
					runType: 'close'
				})
				window.senderWorker.terminate()
				window.senderWorker = undefined	
				this.computeProgress('0%')
				this.reSetTask()
			},
			
			// 发送的数据-初始数据
			senderData(){
				let friendList = localStorage.getItem(this.cacheFansKey)
				let sendOpt = localStorage.getItem(this.cacheOptKey)
				if(friendList == null || sendOpt == null){
					friendList = JSON.parse(JSON.stringify(this.fans))
					sendOpt = JSON.parse(JSON.stringify(this.msgOpt))
					sendOpt.msgIndex = 0
					sendOpt.fansIndex = 0
					if(friendList.length !== 0 && sendOpt.msgList !== undefined){
						let fansGroupData = this.groupFans(friendList)
						friendList = fansGroupData.groupData
						sendOpt.fansGroupMaxLen = fansGroupData.fansGroupMaxLen
						sendOpt.fansTotal = fansGroupData.fansTotal
						localStorage.setItem(this.cacheFansKey,JSON.stringify(friendList))
						localStorage.setItem(this.cacheOptKey,JSON.stringify(sendOpt))
						localStorage.setItem(this.cacheTimeKey,getCurrentTime())
					}
				}else{
					friendList = JSON.parse(friendList)
					sendOpt = JSON.parse(sendOpt)
				}
				this.fansLength = sendOpt.fansTotal
				this.fansGroupMaxLen = sendOpt.fansGroupMaxLen
				this.tempMsgOpt = sendOpt
				this.senderTime = localStorage.getItem(this.cacheTimeKey)
				return {
					friendList,
					sendOpt
				}
			},
			
			// 计算任务进度
			 computeProgress(initVal){
				 let pregress = '100%'
				 if(initVal !== undefined){
					 pregress = initVal
				 }else{
					 if(this.tempMsgOpt.msgList !== undefined){
						 let msgGInfo = this.msgCounterInfo( this.tempMsgOpt.msgList);
						 let total = this.fansGroupMaxLen * msgGInfo.groupCount
						 let currentNum = 0
						 if(this.tempMsgOpt.sendType === 1){
							currentNum = msgGInfo.groupCount * (this.tempMsgOpt.fansIndex) + this.tempMsgOpt.msgIndex + 1
						 }else{
							currentNum = this.fansGroupMaxLen * (this.tempMsgOpt.msgIndex) + this.tempMsgOpt.fansIndex + 1
						 }
						 pregress = Math.ceil(100 * currentNum / total) + '%'
						 if(this.taskStatus == -2){
							pregress = '100%'
						 }
						 this.total = total
						 this.currentNum = currentNum
					 }
				 }
				 this.element.progress('sender-progress', pregress)
			 },
			 
			 // 发送消息
			 send(msg,fans){
				 let sendOpt = localStorage.getItem(this.cacheOptKey)
				 sendOpt = JSON.parse(sendOpt)
				 let msgToUp = true
				 if (sendOpt !== null && sendOpt.msgToUp !== undefined){
					msgToUp = sendOpt.msgToUp
				 }
				 let chatUser = {
					 type: 1,
					 custom_wx_id: fans.custom_open_id,
					 fans_wx_id:fans.open_id,
					 fans_id:fans.id,
					 phone_id: fans.phone_id,
					 fans_wx_name: fans.wx_name
				 }
				 // 判断是否为base64，如果是则上传后发送
				 sendMsg(chatUser,msg.content,msg.type,this,2,'',msgToUp)
			 },
			 
			 // 重新设定任务
			 reSetTask(){
				 this.init()
				 this.element.render('progress','sender-progress')
				 this.$emit('re-set-task')
			 },
			 
			 // 计算消息数据
			 msgCounterInfo(msgList){
			 	let msgCount = 0
			 	let groupCount = 0
			 	for(let i in msgList){
			 		groupCount++
			 		for (var j = 0; j < msgList[i].length; j++) {
			 			msgCount++
			 		}
			 	}
			 	return {
			 		msgCount,
			 		groupCount
			 	}
			 },
			 
			 // 将粉丝按客服进行分组，如果客服分组选项关闭，则把粉丝分到一个组中
			 groupFans(fansList){
				 let groupData = {}
				 let fansGroupMaxLen = 0
				 let fansTotal = fansList.length
				 if(this.msgOpt.fansGroupOpen){
					 for (let i = 0; i < fansList.length; i++) {
							 let key = fansList[i].custom_open_id
					 	if(groupData[key] === undefined){
							groupData[key] = [fansList[i]]
						}else{
							groupData[key].push(fansList[i])
						}
					 }
					 for (let i in groupData) {
					 	if(groupData[i].length > fansGroupMaxLen){
							fansGroupMaxLen = groupData[i].length
						}
					 }
				 }else{
					 groupData.default_group = fansList
					 fansGroupMaxLen = fansList.length
				 }
				 return {
					 groupData,
					 fansGroupMaxLen,
					 fansTotal
				 }
			 }
		},
		
		activated() {
			let _this = this
			// 获取初始数据，只为计算粉丝总数，和发送状态
			this.senderData()
			// layui进度条
			if(_this.element !== null){
				_this.computeProgress('0%')
			}else{
				layui.use('element', function(){
				  _this.element = layui.element
				  _this.computeProgress('0%')
				})
			}
		}
	}
</script>

<style>
	.div-flex{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.chat-helper-se-bg-orange{
		background-color: orange !important;
	}
	.chat-helper-se-bg-blue{
		background-color: #01AAED !important;
	}
	.chat-helper-se-bg-green{
		background-color: #009688 !important;
	}
	.chat-helper-se-bg-red{
		background-color: red !important;
	}
	.chat-helper-se-color-orange{
		color: orange !important;
	}
	.chat-helper-se-color-blue{
		color: #01AAED !important;
	}
	.chat-helper-se-color-green{
		color: #009688 !important;
	}
	.chat-helper-se-color-red{
		color: red !important;
	}
	.chat-helper-se-container{
		height: 100%;
		overflow: hidden;
		position: relative;
		border: 1px solid #e1e1e1;
		box-sizing: border-box;
		border-radius: 4px;
		margin: 0 10px;
		box-sizing: border-box;
	}
	.chat-helper-se-title{
		height: 50px;
		padding: 0 10px;
		line-height: 50px;
		border-bottom: 1px solid #e1e1e1;
		font-size: 16px;
	}
	.chat-helper-se-item{
		padding: 10px;
	}
	.chat-helper-sei-progress{
		margin: 15px 0 5px 0;
	}
	.chat-helper-sei-option{
		display: inline-block;
		height: 24px;
		line-height: 24px;
		padding: 0 10px;
		background-color: #009688;
		color: #FFFFFF;
		margin-right: 10px;
		border-radius: 2px;
		cursor: pointer;
	}
	.chat-helper-sei-status{
		width: 8px;
		height: 8px;
		background-color: #009688;
		transform: rotateZ(45deg);
	}
	.chat-helper-sei-title{
		line-height: 24px;
		width: 72px;
		margin-left: 5px;
	}
	.chat-helper-sei-text{
		line-height: 24px;
		flex-grow: 1;
		width: 0;
	}
	.chat-helper-sei-text{
		color: #666666;
	}
</style>
